module.exports = __webpack_public_path__ + "img/detailfour_title.15a10577.png";